<template>
<div class="col-xl-4 col-md-6 activity-items">
    <div class="card">
        <div class="card-header">
            <h3>Recent Activity</h3>
        </div>
        <div class="card-body">
            <div class="activity-media">
                <div class="d-flex" v-for="(item,index) in menu" :key="index">
                    <div class="recent-circle" :class="item.bgClass"></div>
                    <div class="flex-grow-1">
                        <h6 class="font-roboto">{{item.title}}</h6><span><vue-feather class="me-2" type="clock"></vue-feather><span class="font-roboto">
                            {{item.date}}</span></span>
                    </div>
                </div>
                
            </div> 

            </div>
        </div>
    </div>
</template>

<script>
import {
    RecentActivityData
} from '../../../data/widgets/general/data'
export default {
    name: 'recentactivityPage',
    data() {
        return {
            menu: RecentActivityData
        }
    }
}
</script>
